//
// Handling der Progressbar in Artikel Detail ansicht, check ob hidden, update scroll tiefe
//

import contentTracker from "./InhaltGelesen";

document.addEventListener('DOMContentLoaded', progressBar);

function progressBar() {

    const progressBarArtikel = document.getElementById('iww-readerbar');
    const progressBarNewsletter = document.getElementById('iww-readerbar-newsletter');
    const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);

    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');

    let progressBar = null;

    if (artikeldetail) {
        // Wir befinden uns in Artikeldetail der Fortschrittsbalken ist sichtbar
        // sonst return
        if (!(artikeldetail && fromParam)) {
            return;
        }

        if (progressBarArtikel && !fromParam.includes("nl_")) {
            let heftId = artikeldetail.getAttribute("data-heft-issue");

            if (fromParam !== null && (fromParam !== heftId)) {
                return;
            }

            progressBar = progressBarArtikel.querySelector('#progress_bar');
        } else if (progressBarNewsletter && fromParam.includes("nl_")) {
            progressBar = progressBarNewsletter.querySelector('#progress_bar');
        }

        // Exit hier wenn keine Progressbar vorhanden
        if (progressBar == null || document.getElementById("paywall_login") !== null) {
            return;
        }

        const progressBarMarker = progressBar.parentElement
            ? progressBar.parentElement.querySelector('#progress_bar_marker')
            : null;

        function applyProgress(value) {
            progressBar.style.width = value + '%';
            if (progressBarMarker) {
                progressBarMarker.style.left =
                    'clamp(0.375rem, ' + value + '%, calc(100% - 0.375rem))';
            }
        }

        const newsliste = document.getElementById("newsliste");
        const newslisteTop = newsliste.getBoundingClientRect().top + window.scrollY;
        // Mal 0.9 um Artikel bei 100% gelesen Artikelende in unterem drittel des bildschirms
        const windowHeight = window.innerHeight * 0.9;

        // Einmal onload ausführen um progress auch schon vor dem ersten scrollen zu haben
        let scrollPosition = window.scrollY;
        let progress = (scrollPosition / (newslisteTop - windowHeight)) * 100;

        // progress is capped at 100% even if user scrolls down further
        if (progress > 100) {
            progress = 100;
        }

        applyProgress(progress);

        let aktuelleProgressbar;
        if (fromParam.includes("nl_")) {
            aktuelleProgressbar = document.getElementById("iww-readerbar-newsletter");
        } else {
            aktuelleProgressbar = document.getElementById("iww-readerbar");
        }

        let alleGelesen;
        let gelesenCount = 0;
        let alleArtikelCount = 0;

        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            const startMarkers = aktuelleProgressbar
                ? aktuelleProgressbar.querySelectorAll('[id^="start_marker_"]')
                : [];

            startMarkers.forEach(element => {
                alleArtikelCount = alleArtikelCount + 1;
                let artikelID = element.id.replace("start_marker_", "");

                if (articles_read !== null && articles_read.includes(artikelID)) {
                    gelesenCount = gelesenCount + 1;
                }
            });

            if (gelesenCount == alleArtikelCount && alleArtikelCount !== 0) {
                alleGelesen = true;
            } else {
                alleGelesen = false;
            }



            let aktuellerGelesen = null;

            let artikel = document.querySelector("[id^='artikel_detail']");
            if (artikel !== null) {
                let artikelID = artikel.id.replace("artikel_detail_", "");
                if (articles_read !== null && articles_read.includes(artikelID)) {
                    contentTracker.getContent(artikelID).then(artikelStatusInfo => {
                        if (artikelStatusInfo) {
                            if (parseInt(Math.floor(Date.now() / 1000)) - parseInt(artikelStatusInfo.updateDate) < 20) {
                                aktuellerGelesen = false;
                            } else {
                                aktuellerGelesen = true;
                            }
                        } else {
                            aktuellerGelesen = false;
                        }
                    });
                } else if (articles_read !== null) {
                    aktuellerGelesen = false;
                }
            }

            let finished = false;
            window.addEventListener('scroll', () => {

                let scrollPosition = window.scrollY;

                let progress = (scrollPosition / (newslisteTop - windowHeight)) * 100;
                let scrollDepth = (scrollPosition / (newslisteTop - windowHeight)) * 100;

                // progress is capped at 100% even if user scrolls down further
                if (progress > 100) {
                    progress = 100;
                }

                // Erfolgsmeldung nur beim erstmaligen Abschluss der Ausgabe:
                // alle anderen Artikel gelesen, aktueller gerade erst gelesen, Artikelende erreicht.
                if (!aktuellerGelesen && alleGelesen && (scrollDepth > 90) && !finished) {
                    finished = true;
                    document.dispatchEvent(new CustomEvent('iww:issue-completed'));
                }

                applyProgress(progress);
            });

        });
    }
}
